<template>
	<div :class="{'mt': isDetailPage}">
		<div
			class="c-comparison-list__item--detail-tab-headers u-palm-visuallyhidden u-bg-color--white mt-"
			:class="{'c-comparison-list__item--detail-tab-headers--opened': tabShowing}"
			v-if="!isDetailPage"
		>
			<a
				v-for="tab in tabs.filter(t => t.active)"
				:key="tab.id"
				@click="showTab(tab.id, tab.text)"
				class="c-tabbox__tab c-tabbox__tab-classic"
				:class="{'selected c-tabbox__tab-classic--current' : tabShowing === tab.id}"
			>
				{{tab.text}}
				<template v-if="tab.id === 'assessment'">{{supplierAssessment.AssessmentTotal}}</template>
			</a>
		</div>
		<div
			class="c-comparison-list__item--detail-tab-content"
			:class="{'u-palm-visuallyhidden': !isDetailPage}"
			v-if="tabShowing"
		>
			<div class="layout c-flex-desk" :class="{'mb+': tabShowing}">
				<div
					style="position: relative;"
					class="layout__item u-1/4-desk u-1/1-portable pl+ palm-pl0 pt+"
					:class="{'u-1/1-palm': isDetailPage}"
				>
					<template v-if="isDetailPage">
						<ul class="c-tabbox__tabs o-list-links o-list-links--cta zeta u-portable-text-align--center">
							<li
								v-for="(tab, index) in tabs.filter(t => t.active)"
								:key="tab.id"
								@click="showTab(tab.id)"
								class="c-tabbox__tab o-list-links__item u-portable-display--inline-block portable-small"
							>
								<span class="u-desk-visuallyhidden">{{tab.shortText ? tab.shortText : tab.text}}</span>
								<span class="u-portable-visuallyhidden">{{tab.text}}</span>
								<span
									v-if="index < tabs.length -1"
									class="u-desk-visuallyhidden u-portable-display--inline-block u-text-color-grey portable-ph--"
								>|</span>
							</li>
						</ul>
						<a
							class="c-button c-button--small small mt+ zeta u-palm-visuallyhidden c-sticky-button"
							style
							@click="showOverview()"
						>Terug naar het overzicht</a>
					</template>
					<a
						class="c-button c-button--small mr- ml0"
						@click="togglePackageDetails()"
						v-if="!isDetailPage"
					>Alles over dit pakket</a>
				</div>
				<div class="layout__item c-comparison-list__more-info-content u-3/4-desk u-1/1-portable p">
					<div class="portable-pl">
						<div
							class="is-loading u-text-align--center"
							style="height: 400px;
    position: relative;"
							v-if="tabShowing === 'loading'"
						>
							<svg width="135" height="140" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#eee" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"/><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"/></rect></svg>
						</div>

						<package-prices
							:result-item="resultItem"
							:is-detail="isDetailPage && currentPackageIsDetail"
							:address="address"
							v-if="tabShowing === 'prices'"
						/>
						<package-conditions
							:is-detail="isDetailPage && currentPackageIsDetail"
							:result-item-base-data="resultItemBaseData"
							:result-item="resultItem"
							v-if="tabShowing === 'conditions'"
						/>
						<package-assesment
							:is-detail="isDetailPage && currentPackageIsDetail"
							:result-item="resultItem"
							v-if="tabShowing === 'assessment'"
						/>
						<package-experiences
							:is-detail="isDetailPage && currentPackageIsDetail"
							:result-item="resultItem"
							v-if="tabShowing === 'experiences'"
						/>
					</div>
				</div>
				<div
					class="c-comparison-list__collapse-button-wrapper u-border--top"
					@click="showTab(null)"
					v-if="tabShowing && !isDetailPage"
				>
					<button class="c-comparison-list__collapse-button-inner">
						<span class="c-link u-text-color-brand--support u-white-space--nowrap">
							Inklappen&nbsp;&nbsp;
							<img
								src="@/assets/img/icons/arrow-up-blue.svg"
								alt="Sluit het pakket"
								class="c-comparison-list__more-info-button-arrow"
							/>
						</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Api from '@/services/api.energy';

import PackagePrices from './PackagePrices';
import PackageConditions from './PackageConditions';
import PackageAssesment from './PackageAssessment';
import { eventHub } from '@/services/eventhub';
import PackageExperiences from './PackageExperiences';

export default {
	props: ['resultItemSerialId', 'supplierAssessment', 'address', 'visibleTab', 'resultItemBaseData'],
	components: {
		PackagePrices,
		PackageConditions,
		PackageAssesment,
		PackageExperiences
	},
	data() {
		return {
			resultItem: null,
			dataFetched: false,
			tabs: [
				{
					id: 'prices',
					text: 'Prijsdetails',
					active: true
				},
				{
					id: 'conditions',
					text: 'Pakketvoorwaarden',
					shortText: 'Voorwaarden',
					active: true
				},
				{
					id: 'assessment',
					text: 'Pakketscore',
					shortText: 'Pakketscore',
					// eslint-disable-next-line
					active: APP_SHOWASSESMENT
				}
			],
			tabShowing: null
		};
	},
	updated() {},
	mounted() {
		let totalAssessment = this.resultItemBaseData.ComparisonTabs.ComparisonTabSupplierAssessment.TotalAssessment
			.Value;
		if (totalAssessment !== 'Onvoldoende gegevens') {
			this.tabs[2].text = `Pakketscore ${totalAssessment}`;
		}

		if (this.isDetailPage) {
			this.showTab(this.tabs[0].id);
		}
		eventHub.$on('changed-detail', params => {
			if (this.isDetailPage && params.packageId === this.resultItemSerialId && this.tabShowing === null) {
				this.showTab(this.tabs[0].id);
			}
		});
		eventHub.$on('show-overview', () => {
			this.tabShowing = null;
		});
	},
	methods: {
		async showTab(tabId, tabText) {
			if (!tabId) {
				this.tabShowing = null;
				return;
			}
			if (!this.resultItem) {
				this.tabShowing = 'loading';
				this.resultItem = await Api.getPackageDetailsInContext(this.resultItemSerialId);
				//window.scrollTo(0, 0);
			}

			this.track('Show Tab', tabText);
			this.tabShowing = tabId;
		},
		showOverview() {
			this.$emit('show-overview-from-detail');
		},
		async togglePackageDetails() {
			this.track('Showing detail for package', `${this.resultItem.SupplierUrlName} ${this.resultItem.UrlName}`);
			eventHub.$emit('changed-detail', {
				supplier: this.resultItem.SupplierUrlName,
				package: this.resultItem.UrlName + '-' + this.resultItem.SerialId,
				packageId: this.resultItem.SerialId
			});
		}
	}
};
</script>

<style>
</style>
